module.exports = __webpack_public_path__ + "img/any-mask5.16da368b.png";